import { useState } from "react";
import { updateMintSpace } from "../api/mintSpace";
import { useTranslation } from "../context/TranslationContext";
import { SOCIAL_NETWORKS, socialUrl } from "../utils/socialUrl";
import Icon from "./ds/Icon";
import SocialModal from "./SocialModal";

const TAG =
  "inline-flex h-6 items-center gap-space-4 rounded-radius-sm px-space-8 text-caps-button-s uppercase outline-none transition-colors focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)]";

/*
  A space's social links on its home, as on a profile: visitors get the linked networks as
  tags that open them, and whoever runs the space gets all four to edit in place, the
  linked ones ticked.
*/
const SpaceSocialLinks = ({ mintSpace, canEdit, isDark, setToast, onUpdate }) => {
  const { t } = useTranslation();
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const socials = mintSpace?.socials || {};

  const save = (platform) => async (event) => {
    try {
      const res = await updateMintSpace(mintSpace._id, { socials: { [platform]: event.target.value.trim() } });
      if (res?.success && res.data) onUpdate?.(res.data);
      setToast?.(t("mintSpace.socialLinkSaved"));
    } catch (error) {
      setToast?.(error?.message || t("toasts.error"));
    }
  };

  if (!canEdit) {
    const linked = SOCIAL_NETWORKS.filter(([key]) => socials[key]);
    if (!linked.length) return null;
    return (
      <div className="flex flex-wrap gap-space-8">
        {linked.map(([key, label]) => (
          <a
            key={key}
            href={socialUrl(key, socials[key])}
            target="_blank"
            rel="noreferrer"
            className={`${TAG} bg-fill-secondary text-label-primary hover:bg-fill-primary`}
          >
            {label}
          </a>
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-wrap gap-space-8">
        {SOCIAL_NETWORKS.map(([key, label]) => {
          const linked = Boolean(socials[key]);
          return (
            <button
              key={key}
              type="button"
              aria-pressed={linked}
              onClick={() => {
                setEditing(key);
                setDraft(socials[key] || "");
              }}
              className={`${TAG} ${linked ? "bg-accent-tinted text-accent-tinted-label" : "bg-fill-secondary text-label-primary"}`}
            >
              {!linked && <Icon name="plus" size={12} />}
              {label}
              {linked && <Icon name="check" size={12} />}
            </button>
          );
        })}
      </div>
      <SocialModal
        socialModal={editing}
        setSocialModal={setEditing}
        tempSocialUrl={draft}
        setTempSocialUrl={setDraft}
        handleSocialChange={save}
        isDark={isDark}
      />
    </>
  );
};

export default SpaceSocialLinks;
